<script>
import { eventIsCanRegister, eventIsDealerOnly, eventIsEnd, eventIsStart } from '@utils/zerone-event'
import { eventListButtonStatusItem } from '@utils/zerone-event-status'
import { DEFAULT_BRNAD_ITEM } from '@src/config/brand'

export default {
  props: {
    courseItem: {
      type: Object,
      default: () => {
        return {
          title: 'IxDTW 互動設計年會 2021（多天統一報名）',
          alias: 'ixda2021',
          categoryTitle: '課程',
          type: 'physical',
          dateType: 'multiple',
          registrationType: 'partial',
          registrationStartDate: '2021-08-26 07:59:59',
          registrationEndDate: '2021-10-02 23:59:59',
          canRegisterGroup: 7,
          inProgress: 0,
          canApply: 0,
          seriesNum: 'JHHSX',
          brands: [
            {
              title: 'BlcakBerry',
              alias: 'blcakberry',
              logo: null,
              contact: [
                {
                  name: '王小明',
                  gender: '先生',
                  countryCode: '02',
                  phone: '22221234',
                  extension: '1111',
                },
                {
                  name: '林小花',
                  gender: '先生',
                  countryCode: '02',
                  phone: '22225566',
                  extension: '2222',
                },
              ],
            },
            {
              title: 'VMware',
              alias: 'vmware',
              logo: null,
              contact: [],
            },
          ],
          dateTimeRange: '2021/10/03(日) ~ 2021/10/04(ㄧ)',
        }
      },
    },
  },
  computed: {
    currentBrand() {
      const valueBrand = () => {
        const brandItems = this.courseItem.brands.filter((item) => {
          return item.alias === this.$route.params.brandAlias
        })

        return brandItems[0] || DEFAULT_BRNAD_ITEM
      }

      const defaultBrand = this.courseItem.brands[0] || DEFAULT_BRNAD_ITEM

      return !this.$route.params.brandAlias || !this.courseItem.brands[0] ? defaultBrand : valueBrand()
    },
    isDealerOnly() {
      return eventIsDealerOnly({ ...this.courseItem })
    },
    isCanRegister() {
      return eventIsCanRegister({ ...this.courseItem })
    },
    isStart() {
      return eventIsStart(this.courseItem.registrationStartDate)
    },
    isEnd() {
      return eventIsEnd(this.courseItem.registrationEndDate)
    },
    listButtonStatusItem() {
      return eventListButtonStatusItem({
        ...this.courseItem,
      })
    },
    brandTipTitle() {
      return this.courseItem.brands.map((item) => item.title).join('<br>')
    },
  },
  methods: {
    goToBrandEventItem() {
      this.$router.push({
        name: 'brand-event-item',
        params: {
          brandAlias: this.$route.params.brandAlias || this.courseItem.brands[0]?.alias,
          eventAlias: this.courseItem.alias,
          eventSeriesNum: this.courseItem.seriesNum,
        },
      })
    },
  },
}
</script>
<template>
  <div :class="$style.coursesItem" @click="goToBrandEventItem">
    <div class="coursesItem__tagBox">
      <el-tag v-if="courseItem.type === 'online'" class="isStylePrimary isOutline isAngle mr-2"> <i class="fas fa-circle fa-sm mr-2"></i>LIVE </el-tag>
      <el-tag v-if="isDealerOnly" class="isStylePrimary"> 經銷商限定 </el-tag>
    </div>
    <h5 class="text-small coursesItem__dateTimeRange"> {{ courseItem.dateTimeRange }} </h5>
    <h4 class="coursesItem__title">{{ courseItem.title }}</h4>
    <div class="coursesItem__action">
      <div class="d-flex justify-content-between">
        <div class="mr-2">
          <template v-if="courseItem.brands.length > 1">
            <el-tooltip placement="top">
              <div slot="content" v-html="brandTipTitle"></div>
              <div class="coursesItem__action__brandsText"> 多品牌協辦 </div>
            </el-tooltip>
          </template>
          <template v-else>
            <img :src="currentBrand.logo" :alt="currentBrand.title" />
          </template>
        </div>
        <div class="coursesItem__action__rightBox">
          <BaseButton v-if="listButtonStatusItem.display" :class="listButtonStatusItem.class" class="coursesItem__btn isFull" :disabled="listButtonStatusItem.disabled">
            {{ listButtonStatusItem.title }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.coursesItem {
  position: relative;
  padding: 2.25rem 2.5rem;
  overflow: hidden;
  background: #fff;
  border-radius: 2px;
  box-shadow: $box-shadow-base;
  transition: box-shadow 0.3s;
  cursor: pointer;

  &:hover {
    box-shadow: $box-shadow-base-hover;

    :global {
      .coursesItem {
        &__title {
          color: $color-primary;
        }
      }
    }
  }
  @include max-lg {
    padding: 1.2rem 1.5rem;
  }
  @include max-md {
    padding: 1rem;
  }

  :global {
    .status {
      &__item {
        display: inline-block;

        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }

    .badge {
      &.isDealerOnly {
        padding: 8px 13px;
      }
    }

    .text-small {
      margin-bottom: 0.8rem;
    }

    .coursesItem {
      &__tagBox {
        min-height: 32px;
        margin-bottom: 0.5rem;
      }

      &__title {
        font-size: 1.5rem;
        line-height: 1.6;

        @include line-clamp(2, 2.91em);

        @include max-lg {
          font-size: 1.125rem;

          @include line-clamp(3, 4.5em);
        }
      }

      &__action {
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
        margin-top: 4rem;

        @include max-lg {
          margin-top: 2rem;
        }

        /* @include max-md {
            flex-direction: column;
          } */
        img {
          height: 55px;
          display: inline-block;
          @include max-lg {
            height: 44px;
          }
          // width: 100%;
          // height: 100%;

          /* width: 40%;
            margin-right: 5%;
            @include max-md {
              width: 80%;
              margin-bottom: 1rem;
            } */
        }

        &__brandsText {
          width: 163px;
          max-width: 100%;
          height: 55px;
          line-height: 55px;
          color: $color-primary;
          text-align: center;
          border: 1px solid $color-primary;

          @include max-lg {
            width: 135px;
            height: 44px;
            font-size: 1rem;
            line-height: 44px;
          }
        }
        &__rightBox {
          @include max-lg {
            align-self: center;
          }
        }
      }

      &__btn {
        z-index: 1;
        padding: 1.1rem 10px;
        width: 150px;
        max-width: 100%;
        @include max-lg {
          padding: 0 19px 0 0;
          font-size: 1rem;
          border: 0;
          text-align: right;
          background: transparent;
          &:hover:not(:disabled) {
            color: $color-primary !important;
            background-color: transparent !important;
            border: 0;
            padding: 0 19px 0 0;
          }
          .baseButton__content {
            position: relative;
            &:before {
              content: '\f105';
              font-family: 'Font Awesome 5 Pro';
              position: absolute;
              right: -1rem;
              top: -2px;
              font-size: 1.25rem;
            }
          }
          .isStylePrimary {
            color: $color-primary;
          }
        }
      }
      &__dateTimeRange {
        letter-spacing: 0.1em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @include max-md {
          font-size: 0.875rem;
        }
      }
    }

    .flat-link {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  &:global {
    &.isFlat {
      position: relative;
      display: flex;
      align-items: center;

      &:hover {
        .coursesItem__title {
          color: $color-primary;
        }
      }

      .flat-link {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      // justify-content: space-between;
      .row {
        align-items: center;
        width: 100%;
      }

      .coursesItem__action {
        margin-top: 0;
      }

      .coursesItem__title {
        height: auto;
        margin-bottom: 0;
        font-size: 1.25rem;
      }

      .text-small {
        margin-bottom: 0.5rem;
        font-size: 1rem;
      }

      .badge-outline {
        margin-bottom: 0;
      }

      .isLive-icon {
        margin-right: 0.5rem;
      }

      .coursesItem__action {
        img {
          width: auto;
          min-width: 0;
        }
      }
    }
  }
}
</style>
